// Rotas de admin

import axios from './axiosCustom'

import {
  HOST,
  headers,
} from './apiMotorBgc'

export async function postCreateUser(apiKey, userId, email, permission, orgId, authAccessToken) {
  const data = {
    user_id: userId,
    email: email,
    permission: permission,
    org_id: orgId,
    auth_access_token: authAccessToken,
  }

  const res = await axios({
    method: 'POST',
    url: `${HOST}/admin/user`,
    headers: headers(apiKey),
    data: data,
  })

  return res
}

export async function patchAdminUser(apiKey, userId, authAccessToken, params = {}) {
  const { userEmailToUpdate, userData } = params

  const data = {
    user_id: userId,
    user_email_to_update: userEmailToUpdate,
    data: userData,
    auth_access_token: authAccessToken,
  }

  const res = await axios({
    method: 'PATCH',
    url: `${HOST}/admin/user`,
    headers: headers(apiKey),
    data: data,
  })

  return res
}
